export const FILTER_MENU = [
  {
    text: 'По стоимости',
    value: 'cost',
  },
  {
    text: 'По отзывам',
    value: 'reviews',
  },
];

export const DEFAULT_SORT = 'cost';

export const LIMITS = ['7', '19', '39'];
export const PAGE_SIZE = LIMITS[1];
export const PAGE_NUMBER = 1;

export const STORE_MODULE_NAME = 'modulesList';
export const FETCH_ITEMS = 'fetchItems';
export const SET_ITEMS = 'setItems';
export const SET_COUNT = 'setCount';



// WEBPACK FOOTER //
// ./src/pages/modules/list/consts.ts